import { SadaNotFound } from './styles';

const NotFound = () => <SadaNotFound>404</SadaNotFound>;

export default NotFound;
